import { useEffect, useState } from 'react'

const EMPTY = { startedAt: null, completedAt: null }

export function useActivityTimelineRunClock(streaming, runId) {
  const [clock, setClock] = useState(EMPTY)
  useEffect(() => {
    setClock(EMPTY)
  }, [runId])
  useEffect(() => {
    if (streaming) {
      setClock((prev) => ({
        startedAt: prev.startedAt ?? Date.now(),
        completedAt: null,
      }))
      return
    }
    setClock((prev) =>
      prev.startedAt && !prev.completedAt
        ? { ...prev, completedAt: Date.now() }
        : prev,
    )
  }, [streaming])
  return clock
}
